import {newsTicker} from '../marketing/global'
document.addEventListener('DOMContentLoaded', () => {
    newsTicker()
})